import { render, staticRenderFns } from "./Year05.vue?vue&type=template&id=a1b12ffa&scoped=true&"
import script from "./Year05.vue?vue&type=script&lang=js&"
export * from "./Year05.vue?vue&type=script&lang=js&"
import style0 from "./Year05.vue?vue&type=style&index=0&id=a1b12ffa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b12ffa",
  null
  
)

export default component.exports